// extracted by mini-css-extract-plugin
export default {"holder":"Events_holder__p+ogh","sliderImage":"Events_sliderImage__i46cm"};